'use client'

import React from 'react'

import { Button } from '@/components/ui/button'
import { BackgroundTextGlass } from '@/components/ui/BackgroundTextGlass'

export default function Error({ reset }: { reset: () => void }) {
  return (
    <div className="container py-28 flex justify-center">
      <BackgroundTextGlass className="max-w-2xl">
        <div className="prose dark:prose-invert max-w-none text-center">
          <h2 className="text-xl font-bold mb-4">Oh no!</h2>
          <p className="mb-6">
            There was an issue with our storefront. This could be a temporary issue, please try your
            action again.
          </p>
          <Button onClick={() => reset()} type="button" variant="default">
            Try Again
          </Button>
        </div>
      </BackgroundTextGlass>
    </div>
  )
}
